<template>
  <div class="list-wrapper">
    <div class="list" :style="{ height: height + 'px' }">
      <div v-if="items">
        <div class="header-row">
          <div class="header" style="width:145px">Date</div>
          <div class="header" style="width:70px">ID</div>
          <div class="header" style="width:195px">Name</div>
          <div class="header" style="width:300px">Description</div>
        </div>
        <ListEntry
          v-for="item in items"
          :key="item.id"
          :item="item"
          @clicked="emit('item-clicked', $event)"
        />
      </div>
      <div v-else>No Entries</div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ListEntry from '@/components/utils/ListEntry.vue';

const props = defineProps({ items: Array, height: Number });

const emit = defineEmits(['item-clicked']);

</script>

<style lang="scss" scoped>

.list-wrapper {
  overflow-x: auto;
  max-width: 100%;
}

.list {
  min-width: 800px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  margin-top: 10px;
}

.header-row {
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border: 1px solid rgb(200, 200, 200);
  border-radius: 6px 6px 0 0;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.header {
  font-size: small;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
